import React, {useEffect, useState} from 'react';
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import Upload from "../../../components/UI/upload/upload";
import {Get, Post} from "../../../apis/api";
import { toast } from "react-toastify";
import CustomButton from "../../../components/UI/customButton/customButton";

const DocumentSection = ({data}) => {
  const { t } = useTranslation();
  const [form, setForm] = useState({});
  const [loading, setLoading] = useState(false);

  const handleForm = ({ name, value }) => {
    setForm((prevState) => ({ ...prevState, [name]: value }));
  };
  const handleList = () => {
    setLoading(true);
    Get("crew/panel/profile")
      .then((res) => {
        setForm(res?.details?.data)
      })
      .catch(() => {
        toast.error("خطایی رخ داده");
      })
      .finally(() => {
        setLoading(false);
      });
  };
  useEffect(() => {
    handleList()
  } ,[])

  const handleSubmit = async () => {
    setLoading(true);
    const formData = new FormData();

     Object.keys(form).forEach(key => {
      formData.append(key, form[key]);
    });
    formData.append("form", "files_form");

    try {
      const res = await Post("crew/panel/profile/files", formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
      toast.success(res.msg);
    } catch {
      toast.error("خطایی رخ داده");
    } finally {
      setLoading(false);
    }
  };
  {console.log(form?.passport_file)}
  return (
    <div className={"mt-8"}>
      <div className={"my-container rounded-lg flex flex-col gap-5 w-full bg-white p-5 px-5 md:px-[11%]"}>
        <span className={"text-gray-500"}>
          {"Please upload the documents in one of the formats: jpg, png, pdf."}
        </span>
        <div className={"flex flex-col gap-5"}>
          <div className={"grid grid-cols-2 md:grid-cols-4 gap-1 md:gap-2 md:gap-5"}>
            <Upload defaultValue={ form?.passport_file} onChange={(e) => handleForm({ name: e.name, value: e.value })} en title={"Passport"} name={"passport_file"} />
            <Upload defaultValue={ form?.picture}  onChange={(e) => handleForm({ name: e.name, value: e.value })} en title={"3x4 Photo"} name={"picture"} />
            <Upload defaultValue={form?.reg_file}  onChange={(e) => handleForm({ name: e.name, value: e.value })} en title={t("Reg")} name={"reg_file"} />
            <Upload defaultValue={ form?.cdc_file}  onChange={(e) => handleForm({ name: e.name, value: e.value })} en title={t("CDC")} name={"cdc_file"} />
          </div>
        </div>
      </div>
      <div className={"my-container pt-5"}>
        <div className={"w-full flex justify-between items-center"}>
          <Link to={"/dashboard"} className={"text-main"}>
            {"Close"}
          </Link>
          <div className={"w-[220px]"}>
            <CustomButton loading={loading} onClick={handleSubmit} title={"Save Information"} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default DocumentSection;
